import { ThumbUpIcon } from './ThumbUpIcon';

/**
 * author: Google
 * id C32E4FC9-F3DC-4C67-81FB-62648E3F1AB5
 * name thumb-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thumb-up.svg
 * tags
 */
export const LikeIcon = ThumbUpIcon;
export default LikeIcon